import { getTheme, COLOR as themeCOLOR, SPACE } from '@tcaster/tcaster-theme';
import { transparentize, lighten, darken } from 'polished';

import FONT_SIZE, { fontSizesValueList } from './fontSizes';

const SECONDARY = '#1bafa4';

export const COLOR = {
  ...themeCOLOR,
  greyscale: {
    grey1: '#4A4A4A',
    grey2: '#5F5F5F',
    grey3: '#9B9B9B',
    grey4: '#D8D8D8',
    grey5: '#F3F3F3',
  },
  secondary: SECONDARY,
  white: '#fff',
  tabGrey: '#bababa',
  borderGrey: '#c0c0c0',
  gridGrey: '#efefef',
  darkBlue: '#354556',
  darkBlueLight: lighten(0.1, '#354556'),
  correct: transparentize(0.4, SECONDARY),
  incorrect: transparentize(0.4, themeCOLOR.primary),
  GAT: {
    incorrect: transparentize(0.4, themeCOLOR.primary),
    missing: transparentize(0.4, themeCOLOR.primary),
  },
  darkPrimary: darken(0.1, themeCOLOR.primary),
};

export const breakpoints = [512, 768, 1025, 1280];

export const theme = {
  ...getTheme(),
  // breakpoints: getTheme().breakpoints.map(b => `${b}em`),
  // 1025px is used to make ipad use mobile view.
  breakpoints: breakpoints.map(bp => `${bp}px`),
  colors: COLOR,
  fonts: {
    ...getTheme().fonts,
    data: '"TH Sarabun New", system-ui, sans-serif',
    mono: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  },
  fontSizes: fontSizesValueList,
  fontWeights: {
    light: 300,
    normal: 400,
    bold: 500,
  },
};

export { SPACE, FONT_SIZE };

export default theme;
